<template>
  <div class="payment-methods-wrapper">
    <el-form-item :label="label" prop="paymentMethod">
      <el-radio-group v-model="selectedMethod" @change="handleChange">
        <el-radio v-for="method in availableMethods" :key="method.value" :label="method.value">
          <div class="payment-method-item">
            <i :class="method.icon"></i>
            <span>{{ method.label }}</span>
          </div>
        </el-radio>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'PaymentMethods',
  
  props: {
    // 已选择的支付方式
    value: {
      type: Number,
      default: 1
    },
    
    // 表单标签
    label: {
      type: String,
      default: '支付方式'
    },
    
    // 要显示的支付方式（为空则显示全部）
    methods: {
      type: Array,
      default: () => []
    },
    
    // 是否为会员支付
    isMember: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    return {
      selectedMethod: this.value || 1,
      
      // 所有支付方式
      allMethods: [
        { 
          value: 1, 
          label: '现金', 
          icon: 'el-icon-money',
          available: true
        },
        { 
          value: 2, 
          label: '会员余额', 
          icon: 'el-icon-wallet',
          available: false  // 只有会员才可用，由计算属性控制
        },
        { 
          value: 3, 
          label: '微信支付', 
          icon: 'el-icon-chat-dot-square',
          available: true
        },
        { 
          value: 4, 
          label: '支付宝', 
          icon: 'el-icon-shopping-bag-1',
          available: true
        },
        { 
          value: 5, 
          label: '信用卡', 
          icon: 'el-icon-bank-card',
          available: true
        },
        { 
          value: 6, 
          label: 'LINE Pay', 
          icon: 'el-icon-mobile',
          available: true
        },
        { 
          value: 7, 
          label: '其他', 
          icon: 'el-icon-more',
          available: true
        },
      ]
    };
  },
  
  computed: {
    /**
     * 可用的支付方式列表
     */
    availableMethods() {
      // 如果有指定要显示的方法，则只显示指定的
      let filteredMethods = this.allMethods;
      
      if (this.methods && this.methods.length > 0) {
        filteredMethods = this.allMethods.filter(method => 
          this.methods.includes(method.value)
        );
      }
      
      // 会员余额只对会员可用
      return filteredMethods.map(method => {
        if (method.value === 2) {
          return {
            ...method,
            available: this.isMember
          };
        }
        return method;
      }).filter(method => method.available);
    }
  },
  
  watch: {
    value(newVal) {
      this.selectedMethod = newVal;
    }
  },
  
  methods: {
    /**
     * 处理支付方式变更
     */
    handleChange(value) {
      this.$emit('input', value);
      this.$emit('change', value);
    }
  }
};
</script>

<style scoped>
.payment-methods-wrapper {
  margin-bottom: 20px;
}

.payment-method-item {
  display: flex;
  align-items: center;
  padding: 5px;
}

.payment-method-item i {
  margin-right: 5px;
  font-size: 18px;
}

.el-radio {
  margin-right: 20px;
  margin-bottom: 10px;
}
</style> 